"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("./Button");
var Link_1 = require("./Link");
var svgs_1 = require("../utils/svgs");
var InfoBlock_1 = require("./InfoBlock");
exports.NotificationStatus = InfoBlock_1.InfoBlockStatus;
var Messages = require("../codegen/Messages");
var Aria_1 = require("../resources/Aria");
var Icon_1 = require("../resources/Icon");
var NotificationActionType;
(function (NotificationActionType) {
    /**
     * Triggers an action back to the initiator based on the actionId (synonymous with onClick).
     */
    NotificationActionType[NotificationActionType["ActionLink"] = 0] = "ActionLink";
    /**
     * Navigation hyperlink.
     */
    NotificationActionType[NotificationActionType["Link"] = 1] = "Link";
})(NotificationActionType = exports.NotificationActionType || (exports.NotificationActionType = {}));
var borderClassMap = (_a = {},
    _a[exports.NotificationStatus.Info] = "oui-toast--info",
    _a[exports.NotificationStatus.Success] = "oui-toast--success",
    _a[exports.NotificationStatus.Warning] = "oui-toast--warning",
    _a[exports.NotificationStatus.Critical] = "oui-toast--error",
    _a);
/**
 * OUI toast notification component.
 *
 * @oui-component Notification
 */
var Notification = /** @class */ (function (_super) {
    __extends(Notification, _super);
    function Notification(props) {
        var _this = _super.call(this, props) || this;
        _this.onCloseClick = _this.onCloseClick.bind(_this);
        _this.onActionClick = _this.onActionClick.bind(_this);
        return _this;
    }
    Notification.prototype.onCloseClick = function (event) {
        if (event) {
            event.preventDefault();
            var onClose = this.props.onClose;
            var _a = event, type = _a.type, charCode = _a.charCode;
            if (onClose) {
                if (type === "keypress") {
                    if (charCode === 13 || charCode === 32) {
                        onClose(event);
                    }
                }
                else {
                    onClose(event);
                }
            }
        }
    };
    Notification.prototype.onActionClick = function (actionId, event) {
        if (event && event.currentTarget) {
            event.preventDefault();
            if (this.props.onActionClick) {
                this.props.onActionClick(event, actionId);
            }
        }
    };
    Notification.prototype.render = function () {
        var _this = this;
        var _a = this.props, closeRef = _a.closeRef, title = _a.title, actions = _a.actions, testId = _a.testId;
        var status = this.props.status || exports.NotificationStatus.Info;
        var borderClass = "oui-toast " + borderClassMap[status];
        var icon = React.createElement("div", { className: "oui-icon" }, svgs_1.default(InfoBlock_1.iconSvgMap[status]));
        var closeButton = (React.createElement(Button_1.default, { label: Messages.ToastNotification.closeNotification(), buttonIcon: Icon_1.default.Close, tabIndex: 0, onClick: this.onCloseClick, onKeyPress: this.onCloseClick, ref: closeRef }));
        var links = (actions || []).map(function (action, index) {
            return action.type === NotificationActionType.ActionLink ? (React.createElement(Button_1.default, { key: index, tabIndex: 0, type: Button_1.ButtonType.Button, buttonStyle: Button_1.ButtonStyle.Link, onClick: _this.onActionClick.bind(_this, action.actionId) }, action.title)) : (React.createElement(Link_1.default, { key: index, href: action.href, openInNewWindow: action.openInNewWindow }, action.title));
        });
        return (React.createElement("div", { className: borderClass, role: Aria_1.Roles.Status },
            React.createElement("div", { className: "oui-toast__icon" }, icon),
            React.createElement("div", { className: "oui-toast__content", "data-test-id": testId },
                React.createElement("div", { className: "oui-toast__title" }, title),
                links.length > 0 && React.createElement("div", { className: "oui-toast__links" }, links)),
            React.createElement("div", { className: "oui-toast__close" }, closeButton)));
    };
    return Notification;
}(React.Component));
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map